import { useMemo } from 'react';

import { atom, useAtom } from 'jotai';
import { useParams } from 'react-router-dom';

import { tournamentAtom } from 'atoms/tournament';
import { useFetchSuspensionCodes } from 'hooks/suspension/useFetchSuspensionCodes';
import { useFetchUserPermissions } from 'hooks/userManagement/useFetchUserPermissions';

import { useFetchTournamentRoles } from './useFetchTournamentRoles';
import { useFetchTournamentUrls } from './useFetchTournamentUrls';

const updatedDateStateAtom = atom<boolean>(false);

export const useTournamentContext = () => {
  const updatedDateState = useAtom(updatedDateStateAtom);
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const { tournamentUrls } = useFetchTournamentUrls(tournamentId);
  const { isAdminOrSuperAdmin } = useFetchUserPermissions(tournamentId);
  const { tournamentRoles } = useFetchTournamentRoles(tournamentId);
  const { suspensionPoints } = useFetchSuspensionCodes();
  const [tournament, setTournament] = useAtom(tournamentAtom);

  return useMemo(
    () => ({
      isAdminOrSuperAdmin,
      updatedDateState,
      suspensionPoints,
      tournament,
      tournamentUrls,
      tournamentRoles,
      setTournament,
    }),
    [
      isAdminOrSuperAdmin,
      setTournament,
      suspensionPoints,
      tournament,
      tournamentRoles,
      tournamentUrls,
      updatedDateState,
    ],
  );
};
